import React from "react";

import "./index.css";

const Loading = (props:any) => {
  return (
    <div {...props}>
      <div className="load20">
        <div></div><div></div><div></div><div></div><div></div>
      </div>
      <div className="loading-text">Loading...</div>
    </div>
  )
}

export default Loading